// src/app/operators/paged-response-operators.ts

import { Observable, OperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';
import { PagedResponse } from '../models/paged-response.model';
import { Adapter } from '../models/adapter'; // Votre interface Adapter

/**
 * Opérateur RxJS qui prend une PagedResponse<T> et transforme le tableau d'items (T[])
 * en un tableau d'objets adaptés (D[]), tout en conservant l'objet PagedResponse intact.
 * * @param adapter L'instance de l'Adapter spécifique (ex: SkillAdapter).
 * @returns Une fonction d'opérateur qui retourne un PagedResponse<D> (où D est le type adapté).
 */
export function adaptPagedResponse<T, D>(
    adapter: Adapter<D>
): OperatorFunction<PagedResponse<T>, PagedResponse<D>> {
    
    // map prend le PagedResponse<T> et doit retourner un PagedResponse<D>
    return map((response: PagedResponse<T>) => {
        
        // On adapte chaque item du tableau 'items'
        const adaptedItems = response.items.map(item => adapter.adapt(item));

        // On crée un NOUVEL objet PagedResponse avec les items adaptés
        // et les métadonnées de pagination originales.
        return {
            ...response, // Copie toutes les autres propriétés (pagination, etc.)
            items: adaptedItems, // Remplace les items non adaptés par les items adaptés
        } as PagedResponse<D>;
    });
}